<template>
  <div>
    <PageHeader title="รายงานการจบคอร์สและสอบผ่าน"></PageHeader>
    <b-container class="mt-5 px-5" fluid>
      <b-card class="no-shadow" no-body>
        <b-tabs card>
          <b-tab title="แยกตามการลงทะเบียน" active>
            <CompletedCoursesByEnroll />
          </b-tab>
          <b-tab title="แยกรายบุคคล">
            <CompletedCoursesByLearner />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../../layouts/PageHeader";
import CompletedCoursesByEnroll from "../panel/CompletedCoursesByEnroll.vue";
import CompletedCoursesByLearner from "../panel/CompletedCoursesByLearner.vue";

export default {
  components: {
    PageHeader,
    CompletedCoursesByEnroll,
    CompletedCoursesByLearner,
  },
};
</script>
